






















































































































































































































































































import { storeDokter } from "@/store/modules/dokter";
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import AsesmenAwalRanapMedis from "@/services/AsesmenAwalRanapMedis";
import { appModule } from "@/store/modules/app";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import { storePenunjang } from "@/store/modules/penunjang";
import TandaVital from "@/components/AsesmenAwalGadar/TandaVital.vue";
import { TTV } from "@/types/asesmen";
import PemeriksaanFisik from "@/components/PemeriksaanFisik.vue";
import Antropometri from "@/components/AsesmenAwalGadar/Antropometri.vue";
import CardRiwayatPenyakitTerdahulu from "@/components/pemeriksaan/rpd/CardRiwayatPenyakitTerdahulu.vue";
import { PemeriksaanFisik as PemFisikTypes } from "@/types/pemeriksaan_fisik";
import { userModule } from "@/store/modules/user";
import { confirmRemove } from "@/utility/CommonHelper";
import { storeSpri } from "@/store/modules/spri";
import {
  AsesmenAwalRanapMedisData,
  AsesmenAwalRanapMedisEpisode,
  AsesmenAwalRanapMedisListResponse,
  DraftReasesmenField,
  DraftReasesmenTerapan
} from "@/types/asesmen_awal_ranap_medis";
import FormPrefillService, {
  FieldProvenance,
  PrefillPayload
} from "@/services/FormPrefillService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import DialogPilihPenunjang from "@/components/pemeriksaan/rehabmedik/DialogPilihPenunjang.vue";
import DraftReasesmenDialog from "@/components/pemeriksaan/asesmen-ranap-medis/DraftReasesmenDialog.vue";
import { SOURCES_REASESMEN } from "@/utils/reasesmenDraft";
import moment from "moment";
// import { storePasien } from "@/store/modules/pasien";
// import PasienStore from "@/store/modules/PasienStore";
// import Pasien from "@/store/modules/new/Pasien";

@Component({
  components: {
    TandaVital,
    PemeriksaanFisik,
    Antropometri,
    CardRiwayatPenyakitTerdahulu,
    VCDateTimePicker,
    DialogPilihPenunjang,
    DraftReasesmenDialog
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenRanapMedisPage extends Mixins(PrefillMixin) {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop({ default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "asesmen_awal_ranap_medis";

  /**
   * Path harus match AsesmenAwalRanapMedisPrefillResolver::PATH_MAP values.
   * Path tak dikenal (termasuk *_list) di-skip agar tidak membuat properti
   * non-reaktif — list ditangani PrefillReviewList terpisah.
   */
  prefillResolvePath(path: string) {
    const slotFor = (field: string) => ({
      get: () => (this as any)[field],
      set: (v) => {
        (this as any)[field] = v;
      }
    });
    switch (path) {
      case "tanda_vital.suhu_badan":
        return slotFor("suhu");
      case "tanda_vital.frekuensi_nadi":
        return slotFor("nadi");
      case "tanda_vital.frekuensi_nafas":
        return slotFor("nafas");
      case "tanda_vital.sistole":
        return slotFor("sistole");
      case "tanda_vital.diastole":
        return slotFor("diastole");
      case "tanda_vital.saturasi_oksigen":
        return slotFor("saturasiO2");
      case "tanda_vital.keadaan_umum":
        return slotFor("keadaanUmum");
      case "antropometri.berat_badan":
        return slotFor("bb");
      case "antropometri.tinggi_badan":
        return slotFor("tb");
      // riwayat_penyakit_dahulu sengaja TIDAK di-prefill: input free-text-nya
      // sudah diganti panel RPD terstruktur, sehingga nilai hasil prefill tak
      // terlihat/terkoreksi user tapi tetap tercetak di PDF.
      default:
        return { get: () => "__skip__", set: () => undefined };
    }
  }

  // ───────────────────────────────────────────────────────────────────

  saving = false;
  removing = false;

  records: AsesmenAwalRanapMedisData[] = [];
  episode: AsesmenAwalRanapMedisEpisode | null = null;
  selectedKey: number | "baru" | null = null;
  creatingReasesmen = false;
  recordsLoaded = false;

  draftDialog = false;
  draftLoading = false;
  draftPayload: PrefillPayload | null = null;
  dialogPenunjang = false;
  maxWaktuPemeriksaan = moment()
    .endOf("day")
    .toDate();

  anamnesisId = null;
  examinedAt: string | null = null;
  keluhanUtama = null;
  riwayatPenyakitSekarang = null;
  riwayatPenyakitDahulu = null;
  riwayatPenyakitKeluarga = null;

  tandaVitalId = null;
  keadaanUmum = null;
  suhu = null;
  nadi = null;
  nafas = null;
  sistole = null;
  diastole = null;
  saturasiO2 = null;

  antropometriId = null;
  bb = null;
  tb = null;
  bbl = null;

  fisikId = null;
  kepala = "";
  leher = "";
  dada = "";
  jantung = "";
  paru = "";
  perut = "";
  ekstremitasAtas = "";
  ekstremitasBawah = "";
  statusPubertas = "";
  genital = "";
  tubuhBelakang = "";
  fisikImage = null;

  asesmenId = null;
  penunjang = null;
  diagnosis = null;
  terapi = null;
  dokter = this.canWrite ? this.stateUser.id : null;

  get pemFisikValues() {
    return {
      kepala: this.kepala,
      leher: this.leher,
      dada: this.dada,
      paru: this.paru,
      jantung: this.jantung,
      perut: this.perut,
      ektrimitaAtas: this.ekstremitasAtas,
      ektrimitaBawah: this.ekstremitasBawah,
      statusPubertas: this.statusPubertas,
      fisikImage: this.fisikImage,
      genital: this.genital,
      tubuhBelakang: this.tubuhBelakang
    };
  }

  get antropometriValues() {
    return {
      bb: this.bb,
      tb: this.tb,
      bbl: this.bbl
    };
  }

  get stateUser() {
    return userModule.user;
  }

  get valTtv(): TTV {
    return {
      sistole: this.sistole,
      diastole: this.diastole,
      nadi: this.nadi,
      nafas: this.nafas,
      suhu: this.suhu,
      saturasiO2: this.saturasiO2
    };
  }

  set valTtv(val: TTV) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
    this.nadi = val.nadi;
    this.nafas = val.nafas;
    this.suhu = val.suhu;
    this.saturasiO2 = val.saturasiO2;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get dokterPpds(): string | null {
    if (!this.asesmenId) return null;

    const data = this.records.find(item => item.id === this.asesmenId);

    if (!data || parseInt(data.dokter_id) !== this.dokter) return null;

    return data.dokter_ppds ?? null;
  }

  get asesmenRanapStore() {
    return AsesmenAwalRanapMedisStore;
  }

  get asesmenAwal() {
    return AsesmenMedisIgdStore;
  }

  get asesAwalContent() {
    return this.asesmenAwal.asesmen?.content;
  }

  get surveyPrimer() {
    return SurveyPrimerIgdStore.asesmen;
  }

  get orderLab() {
    return storePenunjang.listorderLab
      .filter(item => item.status == 1)
      .map(({ items }) => items.map(({ name }) => name))
      .flat();
  }

  get orderRadiologi() {
    return storePenunjang.listorderRadiologi
      .filter(item => item.status == 1)
      .map(({ items }) => items.map(({ name }) => name))
      .flat();
  }

  // get isAnyAnamnesisInputed() {
  //   return (
  //     this.keluhanUtama ||
  //     this.riwayatPenyakitSekarang ||
  //     this.riwayatPenyakitDahulu ||
  //     this.riwayatPenyakitKeluarga
  //   );
  // }

  get isAnyUnsavedChange() {
    if (!this.asesmenId && this.paramsFilled) {
      return true;
    } else {
      return false;
    }
  }

  @Watch("isAnyUnsavedChange")
  changeIsAnyUnsavedChange(val) {
    this.asesmenRanapStore.setIsAnyUnsavedChange(val);
  }

  get paramsFilled() {
    return this.keluhanUtama ||
      this.riwayatPenyakitSekarang ||
      this.riwayatPenyakitKeluarga ||
      this.riwayatPenyakitDahulu ||
      this.isAnyTandaVitalInputed ||
      this.isAnyAntropometriInputed ||
      this.isAnyFisikInputed ||
      this.penunjang ||
      this.terapi ||
      this.diagnosis
      ? true
      : false;
  }

  get requestParams() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser.unit_id,
      keluhan_utama: this.keluhanUtama,
      riwayat_penyakit_sekarang: this.riwayatPenyakitSekarang,
      riwayat_penyakit_dahulu: this.riwayatPenyakitDahulu,
      riwayat_penyakit_keluarga: this.riwayatPenyakitKeluarga,
      // anamnesis: this.isAnyAnamnesisInputed
      //   ? {
      //       id: this.anamnesisId,
      //       keluhan_utama: this.keluhanUtama,
      //       riwayat_penyakit_sekarang: this.riwayatPenyakitSekarang,
      //       riwayat_penyakit_dahulu: this.riwayatPenyakitDahulu,
      //       riwayat_penyakit_keluarga: this.riwayatPenyakitKeluarga
      //     }
      //   : null,
      tanda_vital: this.isAnyTandaVitalInputed
        ? {
            id: this.tandaVitalId,
            keadaan_umum: this.keadaanUmum,
            suhu_badan: this.suhu,
            frekuensi_nadi: this.nadi,
            frekuensi_nafas: this.nafas,
            sistole: this.sistole,
            diastole: this.diastole,
            saturasi_oksigen: this.saturasiO2
          }
        : null,
      antropometri: this.isAnyAntropometriInputed
        ? {
            id: this.antropometriId,
            berat_badan: this.bb,
            tinggi_badan: this.tb,
            bbl: this.bbl
          }
        : null,
      pemeriksaan_fisik: this.isAnyFisikInputed
        ? {
            id: this.fisikId,
            kepala: this.kepala,
            leher: this.leher,
            dada: this.dada,
            jantung: this.jantung,
            paru: this.paru,
            perut: this.perut,
            ektrimita_atas: this.ekstremitasAtas,
            ektrimita_bawah: this.ekstremitasBawah,
            status_pubertas: this.statusPubertas,
            genital: this.genital,
            tubuh_belakang: this.tubuhBelakang,
            pemeriksaan_image: this.fisikImage
          }
        : null,
      penunjang: this.penunjang,
      diagnosis: this.diagnosis,
      terapi: this.terapi,
      examined_at: this.formatedExaminedAt,
      dokter_id: this.dokter
    };
  }

  get isAnyTandaVitalInputed() {
    return this.tandaVitalId ||
      this.keadaanUmum ||
      this.suhu ||
      this.nadi ||
      this.nafas ||
      this.sistole ||
      this.diastole ||
      this.saturasiO2
      ? true
      : false;
  }

  get isAnyAntropometriInputed() {
    return this.antropometriId || this.bb || this.tb || this.bbl ? true : false;
  }

  get isAnyFisikInputed() {
    return this.fisikId ||
      this.kepala ||
      this.leher ||
      this.dada ||
      this.jantung ||
      this.paru ||
      this.perut ||
      this.ekstremitasAtas ||
      this.ekstremitasBawah ||
      this.statusPubertas ||
      this.fisikImage
      ? true
      : false;
  }

  get showGetTandaVitalButton() {
    return this.surveyPrimer?.content?.tanda_vital;
  }

  get showGetAnamnesisButton() {
    return this.asesAwalContent?.anamnesis;
  }

  get showGetFisikButton() {
    return this.asesAwalContent?.fisik;
  }

  get showGetPenunjangButton() {
    return this.orderLab.length || this.orderRadiologi.length;
  }

  get spri() {
    return storeSpri.detailspri;
  }

  get showGenerateFromSpriBtn() {
    return !this.asesmenId && !this.records.length;
  }

  get canCreateReasesmen() {
    return this.canWrite && !this.reasesmenDisabledReason;
  }

  get hasCreateAccess() {
    return userModule.canAccessForm("asesmen_awal_ranap_medis", "create");
  }

  get reasesmenDisabledReason(): string | null {
    const episode = this.episode;

    if (this.readOnly) {
      return "Rekam medis sudah terkunci – Reasesmen tidak dapat dibuat.";
    }
    if (!this.records.length) {
      return "Simpan Asesmen Awal terlebih dahulu – Reasesmen belum bisa dibuat.";
    }
    if (!episode || episode.hari_rawat === null) {
      return "Lama rawat tidak dapat dihitung – Reasesmen belum bisa dibuat.";
    }
    if (!episode.boleh_reasesmen) {
      return `Lama rawat belum lebih dari ${episode.batas_hari} hari (saat ini hari ke-${episode.hari_rawat}) – Reasesmen belum bisa dibuat.`;
    }

    return null;
  }

  get isInitialWithReasesmen() {
    return (
      this.records.length > 1 &&
      !!this.asesmenId &&
      this.records[0].id === this.asesmenId
    );
  }

  get reasesmenHints(): string[] {
    const hints: string[] = [];
    const episode = this.episode;

    if (this.creatingReasesmen) {
      hints.push(
        "Simpan atau batalkan reasesmen baru sebelum membuka asesmen lain."
      );
    } else if (this.reasesmenDisabledReason) {
      hints.push(this.reasesmenDisabledReason);
    } else if (episode) {
      hints.push(
        `Lama rawat lebih dari ${episode.batas_hari} hari (saat ini hari ke-${episode.hari_rawat}) – Reasesmen dapat dibuat.`
      );
    }

    if (this.isInitialWithReasesmen && !this.readOnly) {
      hints.push(
        "Asesmen awal tidak dapat dihapus selama masih ada reasesmen."
      );
    }

    return hints;
  }

  get formatedExaminedAt() {
    return this.examinedAt || moment().format("YYYY-MM-DD HH:mm:ss");
  }

  get waktuPemeriksaan(): Date | null {
    if (!this.examinedAt) return null;
    const waktu = moment(this.examinedAt, "YYYY-MM-DD HH:mm:ss", true);
    return waktu.isValid() ? waktu.toDate() : null;
  }

  set waktuPemeriksaan(nilai: Date | null) {
    this.examinedAt = nilai
      ? moment(nilai).format("YYYY-MM-DD HH:mm:ss")
      : null;
  }

  get canWrite() {
    if (this.readOnly) return false;
    // Use form-access matrix: untuk asesmen_awal_ranap_medis, dokter ranap
    // bisa create/edit/sign (sesuai matrix CSV Direksi RSPS).
    // userModule.isMedis tetap di-keep sebagai fallback semantik (compat).
    return (
      userModule.canAccessForm("asesmen_awal_ranap_medis", "create") ||
      userModule.canAccessForm("asesmen_awal_ranap_medis", "edit")
    );
  }

  mounted() {
    this.loadRecords();

    storeSpri.getSpriByRegister(this.register);
  }

  setTtv(val: TTV) {
    this.valTtv = val;
  }

  addDbn(field) {
    if (!this[field]) {
      this[field] = this[field].concat(" Dalam batas normal").trim();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  generateFromSpri() {
    if (this.spri) {
      if (!this.asesmenId) {
        this.keluhanUtama = this.spri.keluhan_utama;
        this.riwayatPenyakitSekarang = this.spri.riwayat_penyakit;
        this.penunjang = this.spri.pemeriksaan_penunjang;
        this.diagnosis = this.spri.diagnosis;
        this.terapi = this.spri.terapi;
      } else {
        appModule.sendErrorAlert(
          "Sudah ada isian Asesmen Awal Rawat Inap. Tidak bisa mengisi isian asesmen dari SPRI!"
        );
      }
    } else {
      appModule.sendErrorAlert("Tidak ada isian SPRI yang bisa didapatkan");
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const id = this.asesmenId;
      const sendRequest = id
        ? AsesmenAwalRanapMedis.update(id, this.requestParams)
        : AsesmenAwalRanapMedis.create(this.requestParams);

      sendRequest
        .then(response => {
          appModule.NoticeDelay("Berhasil Simpan Asesmen Medis");

          this.loadRecords(id || response?.data?.data?.id || null);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  async loadRecords(selectId: number | null = null) {
    const register = this.register;
    const response = await AsesmenAwalRanapMedis.listByRegister(register);

    if (register !== this.register) return;

    const body: AsesmenAwalRanapMedisListResponse = response?.data;
    this.records = body?.data || [];
    this.episode = body?.episode || null;
    this.creatingReasesmen = false;
    this.draftDialog = false;
    this.draftPayload = null;
    this.recordsLoaded = true;
    AsesmenAwalRanapMedisStore.setRecord(this.records[0] || null);

    const target =
      this.records.find(item => item.id === selectId) ||
      this.records[this.records.length - 1];

    if (target) {
      this.selectedKey = target.id;
      this.hydrate(target);
    } else {
      this.selectedKey = null;
      this.startNewRecord();
    }
  }

  labelRecord(index: number) {
    return index === 0 ? "Asesmen Awal" : `Reasesmen ke-${index}`;
  }

  formatTanggal(value: string | null) {
    return value ? moment(value).format("DD-MM-YYYY HH:mm") : "-";
  }

  pilihRecord(key: number | "baru") {
    if (key === "baru" || key === this.selectedKey) return;

    const target = this.records.find(item => item.id === key);

    if (target) {
      this.selectedKey = target.id;
      this.hydrate(target);
    }
  }

  buatReasesmen() {
    if (!this.canCreateReasesmen) return;

    this.creatingReasesmen = true;
    this.selectedKey = "baru";
    this.clearInput();
    this.bukaDraftReasesmen();
  }

  async bukaDraftReasesmen() {
    if (this.readOnly || !this.creatingReasesmen) return;

    const register = this.register;
    this.draftDialog = true;
    this.draftLoading = true;

    try {
      const payload = await FormPrefillService.fetchPrefill(
        String(this.rm),
        this.prefillFormKey,
        {
          register_id: register,
          unit_id: this.stateUser ? this.stateUser.unit_id : undefined,
          sources: SOURCES_REASESMEN
        }
      );

      if (register !== this.register || !this.creatingReasesmen) return;

      this.draftPayload = payload;
    } finally {
      this.draftLoading = false;
    }
  }

  terapkanDraft(hasil: DraftReasesmenTerapan) {
    (Object.keys(hasil.nilai) as DraftReasesmenField[]).forEach(kunci => {
      (this as any)[kunci] = hasil.nilai[kunci];
    });

    if (!hasil.jalur.length || !this.draftPayload) return;

    const provenance: Record<string, FieldProvenance> = {};
    hasil.jalur.forEach(jalur => {
      if (this.draftPayload && this.draftPayload.provenance[jalur]) {
        provenance[jalur] = this.draftPayload.provenance[jalur];
      }
    });
    const tersedia = Object.keys(this.draftPayload.fields);

    FormPrefillService.logAcceptance({
      form_key: this.prefillFormKey,
      pasien_rm: String(this.rm),
      register_id: this.register,
      unit_id: this.stateUser ? this.stateUser.unit_id : null,
      event: hasil.jalur.length >= tersedia.length ? "accepted" : "partial",
      fields: hasil.jalur,
      provenance,
      sources: this.draftPayload.sources
    });
  }

  tambahPenunjang(teks: string) {
    if (!teks) return;

    const sekarang = this.penunjang ? String(this.penunjang).trim() : "";
    this.penunjang = sekarang ? `${sekarang}\n${teks}` : teks;
  }

  batalReasesmen() {
    if (
      this.paramsFilled &&
      !window.confirm("Isian reasesmen yang belum disimpan akan dibuang. Lanjutkan?")
    ) {
      return;
    }

    this.creatingReasesmen = false;
    this.draftDialog = false;
    this.draftPayload = null;
    const latest = this.records[this.records.length - 1];

    if (latest) {
      this.selectedKey = latest.id;
      this.hydrate(latest);
    }
  }

  startNewRecord() {
    this.clearInput();

    if (!this.readOnly) {
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: String(this.rm),
          register_id: this.register,
          unit_id: this.stateUser ? this.stateUser.unit_id : undefined
        });
      });
    }
  }

  hydrate(data: AsesmenAwalRanapMedisData) {
    if (data) {
      this.asesmenId = data.id;
      this.penunjang = data.penunjang;
      this.diagnosis = data.diagnosis;
      this.terapi = data.terapi;
      this.dokter = parseInt(data.dokter_id);
      this.examinedAt = data.examined_at || null;

      // this.anamnesisId = data.anamnesis?.id;
      this.keluhanUtama = data.keluhan_utama;
      this.riwayatPenyakitSekarang = data.riwayat_penyakit_sekarang;
      this.riwayatPenyakitDahulu = data.riwayat_penyakit_dahulu;
      this.riwayatPenyakitKeluarga = data.riwayat_penyakit_keluarga;

      if (data.tanda_vital) {
        this.tandaVitalId = data.tanda_vital.id;
        this.keadaanUmum = data.tanda_vital.keadaan_umum;
        this.suhu = data.tanda_vital.suhu_badan;
        this.nadi = data.tanda_vital.frekuensi_nadi;
        this.nafas = data.tanda_vital.frekuensi_nafas;
        this.sistole = data.tanda_vital.sistole;
        this.diastole = data.tanda_vital.diastole;
        this.saturasiO2 = data.tanda_vital.saturasi_oksigen;
      } else {
        this.tandaVitalId = null;
        this.keadaanUmum = null;
        this.suhu = null;
        this.nadi = null;
        this.nafas = null;
        this.sistole = null;
        this.diastole = null;
        this.saturasiO2 = null;
      }

      if (data.antropometri) {
        this.antropometriId = data.antropometri.id;
        this.bb = data.antropometri.berat_badan;
        this.tb = data.antropometri.tinggi_badan;
        this.bbl = data.antropometri.bbl;
      } else {
        this.antropometriId = null;
        this.bb = null;
        this.tb = null;
        this.bbl = null;
      }

      if (data.pemeriksaan_fisik) {
        this.fisikId = data.pemeriksaan_fisik.id;
        this.kepala = data.pemeriksaan_fisik.kepala;
        this.leher = data.pemeriksaan_fisik.leher;
        this.dada = data.pemeriksaan_fisik.dada;
        this.jantung = data.pemeriksaan_fisik.jantung;
        this.paru = data.pemeriksaan_fisik.paru;
        this.perut = data.pemeriksaan_fisik.perut;
        this.ekstremitasAtas = data.pemeriksaan_fisik.ektrimita_atas;
        this.ekstremitasBawah = data.pemeriksaan_fisik.ektrimita_bawah;
        this.statusPubertas = data.pemeriksaan_fisik.status_pubertas;
        this.genital = data.pemeriksaan_fisik.genital;
        this.tubuhBelakang = data.pemeriksaan_fisik.tubuh_belakang;
        this.fisikImage = data.pemeriksaan_fisik.pemeriksaan_images?.url;
      } else {
        this.fisikId = null;
        this.kepala = "";
        this.leher = "";
        this.dada = "";
        this.jantung = "";
        this.paru = "";
        this.perut = "";
        this.ekstremitasAtas = "";
        this.ekstremitasBawah = "";
        this.statusPubertas = "";
        this.genital = "";
        this.tubuhBelakang = "";
        this.fisikImage = null;
      }
    }
  }

  remove() {
    if (!this.removing) {
      const confirmed = confirmRemove("Asesmen Awal Ranap Medis");

      if (confirmed) {
        this.removing = true;

        AsesmenAwalRanapMedis.destroy(this.asesmenId)
          .then(() => {
            // set store module

            appModule.NoticeDelay("Berhasil Hapus Asesmen Medis");

            this.loadRecords();
          })
          .finally(() => {
            this.removing = false;
          });
      }
    }
  }

  clearInput() {
    console.log("clear input");

    this.asesmenId = null;
    this.penunjang = null;
    this.diagnosis = null;
    this.terapi = null;
    this.dokter = this.canWrite ? this.stateUser.id : null;
    // this.examinedAt = null;

    this.anamnesisId = null;
    this.keluhanUtama = null;
    this.riwayatPenyakitSekarang = null;
    this.riwayatPenyakitDahulu = null;
    this.riwayatPenyakitKeluarga = null;

    this.tandaVitalId = null;
    this.keadaanUmum = null;
    this.suhu = null;
    this.nadi = null;
    this.nafas = null;
    this.sistole = null;
    this.diastole = null;
    this.saturasiO2 = null;

    this.antropometriId = null;
    this.bb = null;
    this.tb = null;
    this.bbl = null;

    this.fisikId = null;
    this.kepala = null;
    this.leher = null;
    this.dada = null;
    this.jantung = null;
    this.paru = null;
    this.perut = null;
    this.ekstremitasAtas = null;
    this.ekstremitasBawah = null;
    this.statusPubertas = null;
    this.genital = "";
    this.tubuhBelakang = "";
    this.fisikImage = null;
    this.examinedAt = null;
  }

  print() {
    AsesmenAwalRanapMedis.print(this.asesmenId);
  }

  updatePemFisikVal(val: PemFisikTypes) {
    this.kepala = val.kepala;
    this.leher = val.leher;
    this.dada = val.dada;
    this.paru = val.paru;
    this.jantung = val.jantung;
    this.perut = val.perut;
    this.ekstremitasAtas = val.ektrimitaAtas;
    this.ekstremitasBawah = val.ektrimitaBawah;
    this.statusPubertas = val.statusPubertas;
    this.genital = val.genital;
    this.tubuhBelakang = val.tubuhBelakang;
    this.fisikImage = val.fisikImage;
  }

  setAntropometri(val) {
    this.bb = val.bb;
    this.tb = val.tb;
    this.bbl = val.bbl;
  }

  // setPemFisik() {
  //   this.kepala = "kepala";
  //   this.leher = "leher";
  //   this.dada = "dada";
  //   this.paru = "paru";
  //   this.jantung = "jantung";
  //   this.perut = "perut";
  //   this.ekstremitasAtas = "ekstremitasAtas";
  //   this.ekstremitasBawah = "ekstremitasBawah";
  //   this.statusPubertas = "statusPubertas";
  //   this.fisikImage = "fisikImage";
  // }

  // setAntropo() {
  //   this.bb = 10;
  //   this.tb = 20;
  //   this.bbl = 30;
  // }
}
